import React from 'react';
import { Box, Text, Stack } from '@mantine/core';
import PropTypes from 'prop-types';
import { colors, fontSize } from '../constants';

const SelectedPlantInfoMobile = ({ selectedPlantData }) => {
	return (
		<Box style={{
			padding: '0vw',
			margin: '2vw',
			height: '20vh',
			maxHeight: '20vh',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			overflow: 'hidden'
		}}>
			{selectedPlantData ? (
				<Box style={{
					height: '100%',
					overflowY: 'auto',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-start'
				}}>
					<Stack gap="0.5vw" align="center">
						<Text style={{
							color: colors.white,
							fontSize: fontSize.lg,
							fontWeight: 'bold',
							textAlign: 'center',
							lineHeight: 1
						}}>
							{selectedPlantData.Common}
						</Text>
						
						<Text style={{
							color: colors.white,
							fontSize: fontSize.sm,
							fontStyle: 'italic',
							textAlign: 'center',
              color: colors.black,
						}}>
							({selectedPlantData.Botanical})
						</Text>
						
						<Box style={{
							display: 'flex',
							justifyContent: 'space-between',
							width: '100%',
							marginTop: '0vw'
						}}>
							<Text style={{
								color: colors.white,
								fontSize: fontSize.xs,
								textAlign: 'center',
								flex: 1,
                color: colors.black,
							}}>
								Height: {selectedPlantData.Height}
							</Text>
							
							<Text style={{
								color: colors.white,
								fontSize: fontSize.xs,
								textAlign: 'center',
                color: colors.black,
								flex: 1
							}}>
								Width: {selectedPlantData.Width}
							</Text>
						</Box>
						
						{selectedPlantData.Notes && (
							<Text style={{
								color: colors.white,
								fontSize: fontSize.sm,
								textAlign: 'left',
								lineHeight: 1.3,
								marginTop: '1vw',

							}}>
								{selectedPlantData.Notes}
							</Text>
						)}
					</Stack>
				</Box>
			) : (
				<Text style={{
					color: colors.white,
					fontSize: fontSize.sm,
					textAlign: 'center',
					opacity: 0.7
				}}>
					No plant currently selected
				</Text>
			)}
		</Box>
	);
};

SelectedPlantInfoMobile.propTypes = {
	selectedPlantData: PropTypes.object
};

export default SelectedPlantInfoMobile;
